import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ClusterLeftContentGrid from './ClusterLeftContentGrid';
import ClusterViewRightContent from './ClusterViewRightContent';

function ClusterView(props) {
  const { project } = props;
  const solutions = project.clusterResponse ? project.clusterResponse.solutions : [];
  const { selectedCluster, clusterSegmentCount } = project;
  
  const [clustersVisible, setClustersVisible] = useState([]);

  // should be hardwired eventually
  const [thresholds, setThresholds] = useState(30);
  const [scatOp, setScatOp] = useState(8);
  const [cellSize, setCellSize] = useState(4);
  const [bandWidth, setBandWidth] = useState(20);
  const [interval, setInterval] = useState(5);

  useEffect(() => {
    if (!project.clusterResponse || !project.selectedCluster)
      return;

    if (project.clusterResponse.errMsg) return;

    const clusters = project.clusterResponse.solutions[project.selectedCluster];
    setClustersVisible(new Array(clusters.segmentCount).fill(true));

  }, [project.clusterResponse, project.selectedCluster])

  return (
    <div data-test="clusterView">
      <ClusterLeftContentGrid
        project={project}
        clusterSegmentCount={clusterSegmentCount}
        selectedCluster={selectedCluster}
        segmentData={
          selectedCluster > -1 && solutions !== undefined
            ? solutions[selectedCluster].segments
            : undefined
        }
        thresholds={thresholds}
        setThresholds={setThresholds}
        cellSize={cellSize}
        setCellSize={setCellSize}
        bandWidth={bandWidth}
        setBandWidth={setBandWidth}
        scatOp={scatOp}
        setScatOp={setScatOp}
        interval={interval}
        setInterval={setInterval}
        clustersVisible={clustersVisible}
        setClustersVisible={setClustersVisible}

      />
      <ClusterViewRightContent
        project={project}
        thresholds={thresholds}
        cellSize={cellSize}
        bandWidth={bandWidth}
        interval={interval}
        scatOp={scatOp}
        clustersVisible={clustersVisible}
      />
    </div>
  );
}

ClusterView.propTypes = {
  project: PropTypes.shape({
    title: PropTypes.string,
    projectId: PropTypes.number,
    clusterResponse: PropTypes.instanceOf(Object),
    selectedCluster: PropTypes.number,
    clusterSegmentCount: PropTypes.number,
  }),
};

export default ClusterView;
